// extracted by mini-css-extract-plugin
export default {"button":"Button_button__sBx4u","fullWidth":"Button_fullWidth__Gkq7M","buttonColorRed":"Button_buttonColorRed__fRG2C"};